<template>
  <div class="p-todo-list">
    <div class="p-todo-list__header">
      {{ title }}
    </div>
    <div class="p-todo-list__body"
      ref="dragDropAreaBox"
      :class="{ 'p-todo-list__drag-over': dragOver, 'p-todo-list__drag-drop-area': this.shouldDisplayDropTrigger}"
    >
      <div v-if="this.shouldDisplayDropTrigger"
        :style="computedDropTriggerStyle"
        class="p-todo-list__drop-trigger"
        @mouseover="dragEnter"
        @mouseleave="dragLeave"
        @mouseup="dragDrop"
      ></div>
      <todo-item
        v-for="todo in this.todos"
        :key="todo.id"
        :todo="todo"
        @dragStarts="cardDragging"
        @dragEnds="cardDragged"
        @edit="openEditDialog(todo)"
        @delete="deleteTodo_(todo)"
        @click.stop.prevent.native="onTodoItemClick(todo)"
      ></todo-item>
      <v-btn
        v-if="hasAccess()"
        color="secondary"
        class="p-todo-list__card p-todo-list__card--add"
        text
        dark
        block
        @click.stop.prevent="openEditDialog(null)"
      >
        <v-icon class="mr-4">mdi-plus-circle-outline</v-icon>
        {{$t('todo.addTodo')}}
        <v-spacer></v-spacer>
      </v-btn>
    </div>

    <edit-dialog
      :dialog.sync="editDialog"
      :todo="editedTodo"
      :status="status"
    ></edit-dialog>

    <view-dialog
      :dialog.sync="viewDialog"
      :todo="viewTodo"
      @edit="openEditDialog"
      @delete="deleteTodo_"
    ></view-dialog>
  </div>
</template>


<script>
import { mapActions } from 'vuex'

import TodoItem from './TodoItem'
import EditDialog from './TodoEditDialog'
import ViewDialog from './TodoViewDialog'

import snackbarMixin from '@/mixins/snackbar.mixin'
import accessMixin from '@/mixins/access.mixin'

export default {
  components: {
    TodoItem,
    EditDialog,
    ViewDialog
  },


  mixins: [
    snackbarMixin,
    accessMixin
  ],


  props: {
    title: String,
    todos: Array,
    status: Number,
    shouldDisplayDropTrigger: Boolean
  },


  data () {
    return {
      editDialog: false,
      editedTodo: null,
      viewDialog: false,
      viewTodo: null,
      dragStarts: false,
      dragOver: false
    }
  },


  computed: {
    computedDropTriggerStyle () {
      return {
        height: `calc(100% - ${this.$refs.dragDropAreaBox.offsetTop + 20 + 'px'})`,
        width: this.$refs.dragDropAreaBox.clientWidth + 'px'
      }
    }
  },


  methods: {
    ...mapActions('todo', ['deleteTodo']),
    ...mapActions('changes', ['removeFromChanges']),

    onTodoItemClick (todo) {
      if (!this.hasAccess()) {
        return false
      }
      this.openViewDialog(todo)
    },

    openEditDialog (todo) {
      this.editDialog = true
      this.editedTodo = todo
    },

    openViewDialog (todo) {
      if (todo) {
        this.removeFromChanges(todo)
      }
      if (this.dragStarts) return
      this.viewDialog = true
      this.viewTodo = todo
    },

    async deleteTodo_ (todo) {
      try {
        const confirm = await this.$confirm(this.$t('todo.deleteTodoConfirm', todo), { trueText: this.$t('delete') })
        if (confirm === true) {
          this.showSnackbarProcessing()
          await this.deleteTodo(todo)
          this.showSnackbarSuccess(this.$t('todo.todoDeleted'))
        }
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      }
    },

    cardDragging (id) {
      this.$emit('cardDragging', id, this.status)
      this.dragStarts = true
    },

    cardDragged () {
      this.dragOver = false
      setTimeout(() => { this.dragStarts = false }, 100)
      this.$emit('cardDragged')
    },

    dragEnter () {
      if (this.shouldDisplayDropTrigger) {
        this.dragOver = true
      }
    },

    dragLeave () {
      this.dragOver = false
    },

    dragDrop () {
      this.dragOver = false
      this.$emit('cardDragged', this.status)
    }
  }
}
</script>
